var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D5D5D5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5925H7.82998L12.71 5.7125C13.1 5.3225 13.1 4.6825 12.71 4.2925C12.32 3.9025 11.69 3.9025 11.3 4.2925L4.70998 10.8825C4.31998 11.2725 4.31998 11.9025 4.70998 12.2925L11.3 18.8825C11.69 19.2725 12.32 19.2725 12.71 18.8825C13.1 18.4925 13.1 17.8625 12.71 17.4725L7.82998 12.5925H19C19.55 12.5925 20 12.1425 20 11.5925C20 11.0425 19.55 10.5925 19 10.5925Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.cec95264832b871305369e682ed6ad72.svg";
export { ForwardRef as ReactComponent };